<template>
  <div class="p-4">
    <div
      class="bg-white rounded-xl p-4 text-sm text-gray-700 mt-[40%] mx-auto shadow-lg border-2"
    >
      <h1 class="text-center">ویرایش اطلاعات</h1>
      <hr class="my-4 border-theme-500" />
      <form action="#" @submit.prevent="updateUser()">
        <VInput
          class="w-full mt-2"
          type="text"
          placeholder="نام و نام خانوادگی"
          v-model="user.name"
        />
        <div class="w-full mt-2">
          <date-picker v-model="user.birthDate"></date-picker>
        </div>
        <VInput
          class="w-full mt-2"
          type="tel"
          placeholder="کد ملی"
          v-model="user.meliCode"
        />
        <VButton class="w-full mt-4 bg-green-700 text-white">ثبت</VButton>
      </form>
    </div>
  </div>

  <date-picker
    class="mt-4"
    color="#f59e0b"
    v-model="user.birthDate"
    custom-input="#input_birthday"
  />
</template>

<script>
import VInput from "@/components/General/VInput";
import VButton from "@/components/General/VButton";
import DatePicker from "vue3-persian-datetime-picker";
import { getUser, updateUser } from "@/API/API";

export default {
  name: "EditProfile",
  components: { VButton, VInput,  DatePicker },
  data() {
    return {
      user: this.$store.state.user,
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    updateUser() {
      updateUser(this.user).then((resp) => {
        this.$swal({
          icon: "success",
          title: "موفق",
          text: resp.data.message,
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
        this.getUser();
      });
    },
    async getUser() {
      this.user = (await getUser()).data.result;
      // Update VUEX Store User Cache
      this.$store.dispatch("setUser", this.user);
    },
  },
};
</script>

<style scoped>
.bg-pattern:before {
  content: "";
  /*background-image: url("../../assets/img/pattern_bg_1.png");*/
  @apply absolute top-0 w-full h-full bg-cover blur-[2px];
}
</style>
